

  // 选择你想要添加/删除class的元素
  const element = document.querySelector('.btn-addcart-fixed');
  
  // 假设这是元素的固定高度，或者你可以通过其他方式计算这个高度
  const elementHeight = element.offsetHeight;
  
  // 滚动事件处理函数
  function handleScroll() {
    // 获取页面滚动的距离
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
    // 判断滚动距离是否超过元素的高度
    if (scrollTop > elementHeight) {
      // 如果超过，给元素添加class
      element.classList.remove('display');
      element.classList.add('btn-addcart-fixed--active');

      
      
    } else {
      // 如果没有超过，从元素中移除class
      element.classList.remove('btn-addcart-fixed--active');
      element.classList.add('display');

    }
  }
  
  // 添加滚动事件监听器
  window.addEventListener('scroll', handleScroll);